import './Stats.css';

function Stats() {
    return (
        <div className='stats'>
            <div className='stats__texts'>
                <h3 className='stats__title'>11&nbsp;лет опыта в&nbsp;мире роскоши</h3>
                <p className='stats__text'>То, что начиналось как страсть к&nbsp;часовому искусству, стало именем, которому доверяют коллекционеры по&nbsp;всему миру</p>
            </div>
            <div className='stats__cards'>
                <div className='stats__card'>
                    <p className='stats__card-number'>3,145</p>
                    <h4 className='stats__card-title'>Продано часов</h4>
                </div>
                <div className='stats__card'>
                    <p className='stats__card-number'>671</p>
                    <h4 className='stats__card-title'>Оригинальных моделей</h4>
                </div>
                <div className='stats__card'>
                    <p className='stats__card-number'>1,500+</p>
                    <h4 className='stats__card-title'>Клиентов</h4>
                </div>
                <div className='stats__card'>
                    <p className='stats__card-number'>193</p>
                    <h4 className='stats__card-title'>Страны</h4>
                </div>
            </div>
        </div>
    );
}

export default Stats